var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import clsx from 'clsx';
import { Form, Formik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import * as Yup from 'yup';
import { Button, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { prefixExReact as c } from '../../helpers/components';
import { apiLogin_AC } from '../../store/actions/api';
import Alert from './Alert';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  min-width: 600px;\n  width: 30%;\n  background: transparent;\n  box-shadow: 0 0px 12px\n    ", ";\n  border-radius: 4px;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  min-width: 600px;\n  width: 30%;\n  background: transparent;\n  box-shadow: 0 0px 12px\n    ",
    ";\n  border-radius: 4px;\n"])), function (prop) {
    console.log('theme', prop.theme, prop);
    return 'black';
});
var Header = styled.div.attrs(function () { return ({
    className: c('header'),
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var Title = styled.div.attrs(function () { return ({
    className: c('title'),
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  fontsize: 20px;\n"], ["\n  fontsize: 20px;\n"])));
var StyledForm = styled(Form).attrs(function () { return ({
    className: c('form'),
}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n"])));
var StyledInput = styled(TextField).attrs(function () { return ({
    className: c('textfield'),
}); })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var MatStyledButton = withStyles({
    root: {
        marginBottom: '12px',
    },
})(Button);
var Footer = styled.div.attrs(function () { return ({
    className: c('footer'),
}); })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background: gray;\n  color: white;\n  display: flex;\n  justify-content: center;\n"], ["\n  background: gray;\n  color: white;\n  display: flex;\n  justify-content: center;\n"])));
var DefaultUIValidation = Yup.object().shape({
    login: Yup.string().required('Required'),
    password: Yup.string().required('Required'),
});
var MatLogin = function (_a) {
    var alerts = _a.alerts, initialValues = _a.initialValues, app = _a.app, loginUIValidation = _a.loginUIValidation, title = _a.title, footer = _a.footer, classes = _a.classes, className = _a.className, formLabels = _a.formLabels;
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return state.authenticate; }), authenticated = _b.authenticated, authenticating = _b.authenticating, error = _b.error;
    return (React.createElement(Container, { className: clsx(className, c('login')) },
        React.createElement(Header, { className: c('header2') },
            React.createElement(Alert, { alerts: alerts, success: authenticated, loggingIn: authenticating, error: error }),
            React.createElement(Title, null, title)),
        React.createElement("div", null,
            React.createElement(Formik, { initialValues: initialValues, onSubmit: function (values) {
                    dispatch(apiLogin_AC(values.login, values.password, app));
                }, validationSchema: loginUIValidation || DefaultUIValidation }, function (_a) {
                var values = _a.values, touched = _a.touched, errors = _a.errors, dirty = _a.dirty, isSubmitting = _a.isSubmitting, handleChange = _a.handleChange, handleBlur = _a.handleBlur;
                return (React.createElement(StyledForm, null,
                    React.createElement(StyledInput, { name: "login", value: values.login, onChange: handleChange, onBlur: handleBlur, helperText: errors.login && touched.login && errors.login, error: !!(errors.login && touched.login), label: formLabels.login, margin: "normal", variant: "outlined" }),
                    React.createElement(StyledInput, { name: "password", label: formLabels.password, type: "password", autoComplete: "current-password", margin: "normal", variant: "outlined", value: values.password, onChange: handleChange, onBlur: handleBlur, error: !!(errors.password && touched.password), helperText: errors.password && touched.password && errors.password }),
                    React.createElement(MatStyledButton, { type: "submit", disabled: !dirty || isSubmitting, className: clsx(classes.submitButton, c('submit-button')), variant: "outlined", color: "primary" }, "Login")));
            })),
        React.createElement(Footer, null, footer)));
};
MatLogin.defaultProps = {
    title: 'Exacta Platform Login',
    footer: 'Powered by Exacta-Platform',
    initialValues: { login: '', password: '' },
    formLabels: { login: 'Login', password: 'Password' },
    alerts: {},
    classes: {},
};
export default MatLogin;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map